import axios from 'axios';

import { MOKA_SERVICE_HOST } from '../../api/constants';

export function getAllExperiences() {
  return axios.get(`${MOKA_SERVICE_HOST}/account/v1/experiences`);
}

export function completeExperience(id) {
  return axios.patch(`${MOKA_SERVICE_HOST}/account/v1/experiences/${id}`, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    is_complete: true,
  });
}
